import {
  EXPERIMENT_NAME_REMOVE_BANNERS,
  EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_ERX,
  EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_SUBNAVIGATION,
  EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_TOP_BANNER,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiment,
} from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const AD_BANNER_IFRAME_SELECTOR = '.m-AdBanner__container iframe'

const bindAdBannerIframeTracking = () => {
  let iframeIsInteractedWith = false
  const boundIframes = new WeakSet<HTMLIFrameElement>()

  const handleMouseEnter = () => {
    iframeIsInteractedWith = true
  }

  const handleMouseLeave = () => {
    iframeIsInteractedWith = false
  }

  const bindIframeListeners = () => {
    const iframes = document.querySelectorAll<HTMLIFrameElement>(
      AD_BANNER_IFRAME_SELECTOR
    )

    iframes.forEach(iframe => {
      if (boundIframes.has(iframe)) {
        return
      }

      iframe.addEventListener('mouseenter', handleMouseEnter)
      iframe.addEventListener('mouseleave', handleMouseLeave)
      boundIframes.add(iframe)
    })
  }

  bindIframeListeners()

  const handleWindowBlur = () => {
    if (!iframeIsInteractedWith) {
      return
    }

    const activeElement = document.activeElement
    const isAdBannerIframe =
      activeElement instanceof HTMLIFrameElement &&
      Boolean(activeElement.closest('.m-AdBanner__container')) &&
      Boolean(activeElement.closest('.o-TopBanner'))

    if (isAdBannerIframe) {
      trackOptimizelyEvent(EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_TOP_BANNER)
    }
  }

  window.addEventListener('blur', handleWindowBlur)

  const observer = new MutationObserver(() => {
    bindIframeListeners()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Initial banner content can appear a bit later after hydration/ad rendering.
  setTimeout(bindIframeListeners, 0)
}

const handleHeaderEvents = () => {
  // Desktop
  bindTrackingEvents([
    {
      selector: '.o-ErxModal__MoreInfoButton',
      event: 'click',
      trackingEvent: EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_ERX,
    },
    {
      selector: '.o-HeaderExtension',
      event: 'click',
      trackingEvent: EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_SUBNAVIGATION,
    },
  ])

  bindAdBannerIframeTracking()
}
export default async () => {
  const {
    pageProperties: { experiments },
  } = store.getState().publicRuntimeConfig
  const experiment = getExperiment(EXPERIMENT_NAME_REMOVE_BANNERS, experiments)
  if (experiment.isEnabled) {
    handleHeaderEvents()
    await activateExperiment(EXPERIMENT_NAME_REMOVE_BANNERS)
  }
}
